import React, { useState, useEffect, useRef } from "react";
import "../../style/UserCreateForm.css";
import Loading from "../../components/loading.jsx";
import Sidebar from "../../components/sidebar.jsx";
import { BASE_URL, Renko_Data_API } from "../../utils/config.js";
import { Button } from 'primereact/button';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import RefreshIcon from '@mui/icons-material/Refresh';
import IndexIntradayTable from "../../components/dashboard/indexIntradayTable.js"
import { renko } from "react-stockcharts/lib/indicator";
import ViewRenkoChart from '../../components/Charts/viewRenkoChart.js';
import { Modal, Alert } from "react-bootstrap";


const ViewRenko = () => {


	const [tabs, setTabs] = useState([
		{ id: 'IndexIntraday', label: 'IndexIntraday', data: [], previousClose: [], active: false },
	]);
	const [indexIntradayRecord, setIndexIntradayRecord] = useState(0)
	const [selectedTabId, setSelectedTabId] = useState('IndexIntraday')
	const ALLRenkoData = JSON.parse(localStorage.getItem("ALLRenkoData"));
	const ViewAutomationSymbol = localStorage.getItem("ViewAutomationSymbol");
	
	const [Symbols, setSymbols] = useState(ViewAutomationSymbol ? ViewAutomationSymbol : "NIFTY");
	const [RenkoIntervalDecission, setRenkoIntervalDecission] = useState([{
		"prv_prv_interval": "",
		"prv_interval": "",
		"present_interval": ""
	}]);
	const [AllRenko, setAllRenko] = useState(ALLRenkoData ? ALLRenkoData.filter((item) => item.name === Symbols) : [{
		"interval": '375',
		"brick_size": '100',
		"buy_sell_box": "2",
		"ExitBox": 1
	}]);

	const [data, setData] = useState([]);
	const [RenkoInterval, setRenkoInterval] = useState(ALLRenkoData ? AllRenko[0].interval : '375');
	const [reversalType, setReversalType] = useState(ALLRenkoData ? AllRenko[0].range_mode : "fixed");
	const [BrickSize, setBrickSize] = useState(ALLRenkoData
		? AllRenko[0].range_mode === "atr" ? AllRenko[0].atr_brick ? AllRenko[0].atr_brick : 30 : AllRenko[0].brick_size
		: '100');


	const [BuySellBox, setBuySellBox] = useState(ALLRenkoData ? AllRenko[0].buy_sell_box : '2');

	const [ExitBox, setExitBox] = useState(ALLRenkoData ? AllRenko[0].ExitBox : '1');
	const [atrData, setatrData] = useState(ALLRenkoData ? AllRenko[0].atr === null ? 0 : AllRenko[0].atr : 0);


	const [loader, setLoader] = useState(false);
	const [sourcePath, setsourcePath] = useState("close");
	const [showDialog, setshowDialog] = useState(false);
	const [showatrDialog, setshowatrDialog] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorMsz, setErrorMsz] = useState("");
	const [RenkoDialogData, setRenkoDialogData] = useState({
		Symbols: Symbols,
		RenkoInterval: RenkoInterval,
		BrickSize: BrickSize,
		reversalType: reversalType,
		BuySellBox: BuySellBox,
		ExitBox: ExitBox,
	});



	const [lastupdatedtime, setlastupdatedtime] = useState("");
	const [rotation, setRotation] = useState(0);


	const [lastbrick, setlastbrick] = useState({});

	const SymbolsRef = useRef(Symbols);
	const BrickSizeRef = useRef(BrickSize);
	const RenkoIntervalRef = useRef(RenkoInterval);
	const reversalTypeRef = useRef(reversalType);


	
	useEffect(() => {
		setLoader(true);

		handleIntervalDecission();
		fetchRenkoData();
		fetchShowAll();

		const intervalId = setInterval(() => {
			fetchRenkoData();
			handleIntervalDecission();
		}, 30000);

		const atrinterval = setInterval(() => {
			// console.log("reversalType", reversalTypeRef.current);

			if (reversalTypeRef.current === "atr") {

				fetchAtrBrick();
			}
		}, 5000);

		return () => {
			clearInterval(atrinterval);
			clearInterval(intervalId);
		};

	}, []);





	let count1 = 0;
	useEffect(() => {
		console.log("Windows width", window.innerWidth);

		const fetchDataInterval = setInterval(async () => {
			await fetchDataForAllTabs(selectedTabId);

		}, 60000);   //0,000 milliseconds = 1 minute

		if (count1 === 0) {
			fetchDataForAllTabs(selectedTabId);
			count1 += 1;
		}
		// Cleanup the interval on component unmount
		return () => clearInterval(fetchDataInterval);
	}, []);



	// Function to fetch Renko data
	const fetchRenkoData = async () => {
	
		console.log("fetch check Symbols", Symbols);
		try {
			const url = `${Renko_Data_API}get_5min_data?symbol=${SymbolsRef.current}
        &Brick_size=${BrickSizeRef.current}
        &interval=${RenkoIntervalRef.current}
        &Signal_box=${BuySellBox}
        &ExitBrick=${ExitBox}`.replace(/\s+/g, ''); // Remove whitespace

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
				},
			});

			if (!response.ok) {
				throw new Error(`Error: ${response.statusText}`);
			}
	
			const text = await response.text();

			if (!text || text.trim().length === 0) {
				throw new Error("API returned empty response");
			}

			// Fix NaN values by replacing them with null before parsing JSON
			const fixedJson = text.replace(/\bNaN\b/g, "null");
			let data
			try {
				data = JSON.parse(fixedJson);
			} catch (jsonErr) {
				console.error("Failed to parse JSON:", jsonErr);
				throw new Error("Invalid JSON format in API response");
			}
	
			if (!Array.isArray(data) || data.length < 2) {
				throw new Error("API returned insufficient or malformed data");
			}

			const parsedData = data.slice(1).map((row) => ({
				date: new Date(row.datetime),
				open: row.ROpen,
				high: row.RHigh,
				low: row.RLow,
				close: row.Rclose,
				RDecision_final: row.RDecision_final
				// volume: parseInt(row.volume),
			}));

			const renkoCalculator = renko()
				.options({
					reversalType: reversalType,
					fixedBrickSize: parseFloat(BrickSize >= 1 ? (BrickSize < 500 ? BrickSize : 100) : 1),
					sourcePath: sourcePath,
				});

			const calculatedData = renkoCalculator(parsedData).map((d, index) => ({
				...d,
				RDecision_final: parsedData[index]?.RDecision_final || "UNKNOWN",
			}));

			setlastbrick(calculatedData[calculatedData.length - 1]);

			setData(parsedData);
			setLoader(false);
		} catch (error) {
			console.error("Error fetching Renko data:", error);
			setLoader(false);
			setErrorMsz(`Error: ${error.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);
		}
	};


	
//  this function is used to get  all renko data 
	const fetchShowAll = async () => {

		try {
			console.log("show all symbol", Symbols);
			let loginuser = JSON.parse(localStorage.getItem("loginData"));

			 await fetch(`${BASE_URL}/renkoShowAll`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${loginuser.token}`
				},
			}).then(response => response.json())
				.then(res => {
					const data = res
					console.log("response", data.data);
					if (res.status === 200) {

						setAllRenko(data.data.filter((item) => item.name === SymbolsRef.current));


						console.log("data.data.filter((item) => item.name === Symbols)", data.data.filter((item) => item.name === SymbolsRef.current));
						let filterData = data.data.filter((item) => item.name === SymbolsRef.current)

						if (filterData[0].range_mode === "atr") {

							setBrickSize(filterData[0].atr_brick ? filterData[0].atr_brick : 30);
						}
						else {
							setBrickSize(filterData[0].brick_size)
						}



						setRenkoInterval(filterData[0].interval);
						setBuySellBox(filterData[0].buy_sell_box);
						setExitBox(filterData[0].ExitBox);
						setReversalType(filterData[0].range_mode);



						localStorage.setItem("ALLRenkoData", [JSON.stringify(data.data)]);


						setLoader(false);
					} else {
						setLoader(false);
						setErrorMsz(`Error: ${res.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);
					}
				}).catch((error)=>{
					setErrorMsz(`Error: ${error.message}`)
					setErrorDialog(true)
					setTimeout(() => {
						setErrorDialog(false)
						setErrorMsz('')
					}, 2000);
				})

		} catch (error) {

			console.log("error fetching get api", error);
			setLoader(false)
			
			setErrorMsz(`Error: ${error.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);
		}
	}


	//   this fucntion used to fetch atr from DB
	const fetchAtrBrick = async () => {
		try {
			let loginuser = JSON.parse(localStorage.getItem("loginData"));

			 await fetch(`${BASE_URL}/renkoShowAll`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${loginuser.token}`
				},
			}).then(response => response.json())
				.then(res => {
					const data = res
					// console.log("response", data.data);
					if (res.status === 200) {

						// console.log("checking condition", reversalType === "atr");
						// console.log("checking reversalType", reversalType);
						// console.log("checking RenkoDialogData reversalType", RenkoDialogData.reversalType);

						// console.log("data.data.filter((item) => item.name === Symbols)", data.data.filter((item) => item.name === Symbols));
						let filterData = data.data.filter((item) => item.name === SymbolsRef.current)

						setBrickSize(filterData[0].atr_brick);
						setatrData(filterData[0].atr);







						setLoader(false);
					} else {
						setLoader(false);
						setErrorMsz(`Error: ${res.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);
					}
				}).catch((error)=>{
					setErrorMsz(`Error: ${error.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);
				})

		} catch (error) {

			console.log("error fetching get api", error);
			setLoader(false)
			setErrorMsz(`Error: ${error.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);
		}
	}


	// this function is used to fetch all renko data
		const fetchDataForAllTabs = async (tabId) => {
		console.log("fetch record details for tabId:", tabId);
		try {
			let updatedTabs = [...tabs]; // Clone the tabs array to update its state
			let tab = updatedTabs.find(t => t.id === tabId); // Find the tab with the matching tabId

			if (!tab) {
				console.error('Tab not found:', tabId);
				return;
			}
			const loginuser = JSON.parse(localStorage.getItem('loginData'));
			await fetch(`${BASE_URL}/renkoAutomateData`, {
				method: 'GET',
				headers: {
					'Authorization': `Bearer ${loginuser.token}`
				},
			})
				.then(response => response.json())
				.then(res => {
					// Process the API response data
					if (res.status === 200) {
						console.log("index intraday res.data", res.AutomateData);

						if (tabId === 'IndexIntraday') {
							setIndexIntradayRecord(prevCount => prevCount + 1);
						}

						tab.data = res.AutomateData;

					} else {
						console.error('Error in response:', res);
						tab.data = []
		//				setErrorMsz(`Error: ${res.message}`)
		//	setErrorDialog(true)
		//	setTimeout(() => {
		//		setErrorDialog(false)
		//		setErrorMsz('')
		//	}, 2000);
					}
				})
				.catch(error => {
					// Handle errors
					console.error('Error fetching data:', error);
					setErrorMsz(`Error: ${error.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);
				});

			// Update the state with the new tabs array
			setTabs(updatedTabs);

			// Handle tab-specific logic


		} catch (error) {
			console.error('Error fetching data:', error);
			setErrorMsz(`Error: ${error.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);
		}
	};

	// this function is used to udpdate renko all data 
	const updateSLchangefunction = async (tabId) => {

		fetchDataForAllTabs(tabId);

	}



//  this fucntion is used to handle number change
	const handleNumber = (e) => {
		const value = e.which ? e.which : e.keyCode;
		if (value < 48 || value > 58) {
			e.preventDefault();
		}

	}

//  this function is used to change values
	const handleValueChange = () => {
		setshowDialog(false);
		setLoader(true);
		localStorage.setItem("ViewAutomationSymbol", RenkoDialogData.Symbols)

		// console.log(RenkoDialogData);
		setBrickSize(RenkoDialogData.BrickSize);
		setRenkoInterval(RenkoDialogData.RenkoInterval);
		setReversalType(RenkoDialogData.reversalType);
		setSymbols(RenkoDialogData.Symbols);
		// console.log("RenkoDialogData.reversalType", RenkoDialogData.reversalType);

		// setAtrValid(RenkoDialogData.reversalType === "atr" ? true : false);
		// setAllRenko(ALLRenkoData.filter((item) => item.name === RenkoDialogData.Symbols));

		// setAllRenko((prevState) => {
		// 	if (prevState.length > 0) {
		// 		return prevState.map((item, index) =>
		// 			index === 0 ? { ...item, range_mode: RenkoDialogData.reversalType } : item
		// 		);
		// 	}
		// 	return prevState; // Keep it unchanged if empty
		// });

		// Log updated state after a delay to reflect changes
		// setTimeout(() => {
		// 	console.log("change in rtr", AllRenko);
		// }, 0);
		// fetchRenkoData();

		SymbolsRef.current = RenkoDialogData.Symbols;
		BrickSizeRef.current = RenkoDialogData.BrickSize;
		RenkoIntervalRef.current = RenkoDialogData.RenkoInterval;
		reversalTypeRef.current = RenkoDialogData.reversalType;
		fetchRenkoData();
		handleIntervalDecission();

	}


//  this function is used to format date and time
	function formatDateTime(dateString) {
		const [datePart, timePart] = dateString.split('T'); // Split date and time
		const [year, month, day] = datePart.split('-'); // Extract date components
		const time = timePart.split('.')[0]; // Remove milliseconds

		return `${day}-${month}-${year} ${time}`;
	}


// this function is used to fetch interval data
	const handleIntervalDecission = async () => {
		try {
			let loginuser = JSON.parse(localStorage.getItem("loginData"));

			const response = await fetch(`${BASE_URL}/renkoIntervalData`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${loginuser.token}`
				},
			});
			const Decission = await response.json();
			console.log("handleIntervalDecission", Decission.intervalData.filter((items) => items.name === SymbolsRef.current));
			setRenkoIntervalDecission(Decission.intervalData.filter((items) => items.name === SymbolsRef.current));
			const lastupdateddata = Decission.intervalData.filter((items) => items.name === SymbolsRef.current);
			setlastupdatedtime(formatDateTime(lastupdateddata[0].last_updated_time))

		} catch (error) {
			console.log("Error fetching Interval decission data", error);
			setErrorMsz(`Error: ${error.message}`)
			setErrorDialog(true)
			setTimeout(() => {
				setErrorDialog(false)
				setErrorMsz('')
			}, 2000);

		}
	}



	//  this fucntion is used to set brick color
	const handleDecissionColor = (value) => {
		switch (value) {
			case "HOLD":
				return "black";   //black
			case "EXIT":
				return "#FFB200"; //yellow
			case "BUYYES":
				return "#5B913B"; //green
			case "SELLYES":
				return "red";  // red
			default:
				return "#DA498D"; //purple
		}
	};


//  this function is used to handle close dialog
	const handleCloseDialog = () => {
		setshowDialog(false);
		setRenkoDialogData({
			Symbols: Symbols,
			RenkoInterval: RenkoInterval,
			BrickSize: BrickSize,
			reversalType: reversalType,
			BuySellBox: BuySellBox,
			ExitBox: ExitBox,
		})
	}

	//  this function is used to handle open dialog
	const handleOpenDialog = () => {
		setshowDialog(true);
		setRenkoDialogData({
			Symbols: Symbols,
			RenkoInterval: RenkoInterval,
			BrickSize: BrickSize,
			reversalType: reversalType,
			BuySellBox: BuySellBox,
			ExitBox: ExitBox,
		})
	}



	return (
		<>




			<Sidebar />

			<h1 className="RenkoChart_Heading">View Mode</h1>
			<div className="RenkoChart_Group">
				<div className="RenkoChart_Container">
					<div className="Renko_Decission_Container">
						<div className="Renko_Decission_group">
							<div className="Renko_Decission_header">Last 3 intervals</div>
							{RenkoIntervalDecission?.[0] && (
								<>
									<div className="Renko_Decission_content" style={{ color: handleDecissionColor(RenkoIntervalDecission[0].prv_prv_interval), border: `1px solid ${handleDecissionColor(RenkoIntervalDecission[0].prv_prv_interval)}` }}>
										{RenkoIntervalDecission[0].prv_prv_interval}
									</div>
									<div className="Renko_Decission_content" style={{ color: handleDecissionColor(RenkoIntervalDecission[0].prv_interval), border: `1px solid ${handleDecissionColor(RenkoIntervalDecission[0].prv_interval)}` }}>
										{RenkoIntervalDecission[0].prv_interval}
									</div>
									<div className="Renko_Decission_content" style={{ color: handleDecissionColor(RenkoIntervalDecission[0].present_interval), border: `1px solid ${handleDecissionColor(RenkoIntervalDecission[0].present_interval)}` }}>
										{RenkoIntervalDecission[0].present_interval}
									</div>
								</>
							)}
							<div className="Renko_Decission_header">{lastupdatedtime}</div>

						</div>
					</div>
					<div className="ReckoChart_Container">
						{data.length > 0 ? (
							<div>
								{loader && (
									<div className="Renko_Loader">
										<Loading />
									</div>
								)}
								

								<ViewRenkoChart
									data={data}
									BrickSize={BrickSize}
									reversalType={reversalType}
									Symbols={Symbols}
									width={(window.innerWidth) - (window.innerWidth > 720 ? "350" : "")}
									sourcePath={sourcePath}
									ratio={1.0}
									type="svg"
								/>


							</div>
						) : (
							<div className="Renko_Loader">{loader && <Loading />}</div>
						)}
					</div>
				</div>

				<div className="Renko_Option_Container">

					<div className="Renko_Option_group">

						<div className="ChartCurrent_Container">
							<div className="ChartCurrent_group">
								<div style={{ display: 'flex' }}>
									<div className="ChartCurrent_Box">{Symbols}</div>
									<div className="ChartCurrent_Price" >{lastbrick.close}</div>
								</div>
							</div>

							<div className="ChartCurrent_Refrersh" onClick={() => {
								fetchShowAll()
								setRotation(rotation + 360);
							}}
								style={{
									transform: `rotate(${rotation}deg)`,
									transition: "transform 1s ease-in-out",
									cursor: "pointer"
								}}
							>
								<RefreshIcon style={{ color: 'white' }} />
							</div>

						</div>
					</div>

					<div className="Renko_Option_group">
						<label>Symbol</label>
						<div className="Renko_Option_group_Box" onClick={handleOpenDialog}>{Symbols}</div>

					</div>

					<div className="Renko_Option_group">
						<label>Interval</label>
						<div className="Renko_Option_group_Box" onClick={handleOpenDialog}>{RenkoInterval}</div>

					</div>


					<div className="Renko_Option_group">
						<label>Range Mode</label>
						<div className="Renko_Option_group_Box" onClick={handleOpenDialog}>{reversalType}</div>

					</div>

					<div className="Renko_Option_group">
						<label>Brick size</label>
						<div className="Renko_Option_group_Box" onClick={handleOpenDialog}>{BrickSize}</div>


					</div>


					{reversalType === "atr" &&

						<div className="Renko_Option_group">
							<label>ATR</label>
							<div className="Renko_Option_group_Box"
								readOnly
								style={{
									backgroundColor: '#f0f0f0',
									color: '#727D73',
									cursor: 'not-allowed'
								}}
							>{atrData}</div>


						</div>
					}


					<div className="Renko_Option_group">
						<button className="Renko_Option_button" onClick={() => setshowDialog(true)}>View</button>
					</div>






				</div>





			</div>

			<div style={{ padding: '0 40px', marginTop: '20px' }}>
				{tabs[0].data.length === 0 ? null :
					<IndexIntradayTable Record={tabs[0].data} heading={'IntraDay Tab'} RecordColor={indexIntradayRecord} PreviousClose={tabs[0].previousClose} updateSLchange={() => updateSLchangefunction(tabs[0].id)} tablename={"AutomateIndexIntradaySL"} />
				}
			</div>




			{/* show atr pop up */}
			<Modal
				show={showatrDialog}
				onHide={() => setshowatrDialog(false)}
				style={{ zIndex: 1500 }}
			>
				<Alert variant="danger">
					You have selected ATR
				</Alert>
			</Modal>





			{/* Edit Dialog box  */}


			<Dialog
				open={showDialog}
				onClose={() => { setshowDialog(false) }}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle style={{ color: "#2380DE" }} id="alert-dialog-title">
					{"Renko Details Update"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">


						<div className="Dialog_Option_Container">


							<div className="Dialog_Option_group">
								<label>Symbol</label>
								<select
									value={RenkoDialogData.Symbols}
									onChange={(e) => {

										setRenkoDialogData((prev) => ({
											...prev,
											Symbols: e.target.value
										}))
										const data = ALLRenkoData.filter((item) => item.name === e.target.value);
										setRenkoDialogData((prev) => ({
											...prev,
											Symbols: data[0].name,
											RenkoInterval: data[0].interval,
											BrickSize: data[0].range_mode === "atr" ? data[0].atr_brick : data[0].brick_size,
											reversalType: data[0].range_mode,
										}));
										setatrData(data ? data[0].atr === null ? 0 : data[0].atr : 0)

									}}
								>
									<option value="NIFTY">Nifty</option>
									<option value="BANKNIFTY">Banknifty</option>
									<option value="NIFTY_MID_SELECT">Midcap</option>
									<option value="FINNIFTY">Finnifty</option>
								</select>
							</div>

							<div className="Dialog_Option_group">
								<label>Interval</label>
								<select
									value={RenkoDialogData.RenkoInterval}
									onChange={(e) => {
										// setRenkoInterval(e.target.value);
										setRenkoDialogData((prev) => ({
											...prev,
											RenkoInterval: e.target.value
										}))
										// updateLocalStorage("RenkoInterval", e.target.value);
									}}
								>
									<option value="5">5 minutes</option>
									<option value="10">10 minutes</option>
									<option value="15">15 minutes</option>
									<option value="25">25 minutes</option>
									<option value="30">30 minutes</option>
									<option value="35">35 minutes</option>
									<option value="45">45 minutes</option>
									<option value="60">60 minutes</option>
									<option value="120">120 minutes</option>
									<option value="125">125 minutes</option>
									<option value="375">1 Day</option>
								</select>
							</div>

							<div className="Dialog_Option_group">
								<label>Range Mode</label>
								<select
									value={RenkoDialogData.reversalType}
									onChange={(e) => {
										const data = ALLRenkoData.filter((item) => item.name === RenkoDialogData.Symbols);
										
										setRenkoDialogData((prev) => ({
											...prev,
											reversalType: e.target.value,
											BrickSize: e.target.value === "atr" ? data[0].atr_brick : data[0].brick_size,
										}))

									
									}}
								>
									<option value="atr">Average True Range</option>
									<option value="fixed">Fixed</option>
								</select>
							</div>

							<div className="Dialog_Option_group">
								<label>Brick size</label>

								<input
									type="text"
									value={RenkoDialogData.BrickSize}
									onKeyPress={(e) => handleNumber(e)}
									readOnly={RenkoDialogData.reversalType === "atr"}
									style={RenkoDialogData.reversalType === "atr" ? {
										backgroundColor: '#f0f0f0',
										color: '#727D73',
										cursor: 'not-allowed'
									} : {}}
									onClick={() => {
										if (RenkoDialogData.reversalType === "atr") {
											setshowatrDialog(true);
											// alert("You have selected ATR")
											setTimeout(() => {
												setshowatrDialog(false);

											}, 500);
										}
									}}
									onChange={(e) => {
										if (RenkoDialogData.reversalType === "atr") {
											return; // Prevent any changes when ATR is selected
										}

										const value = parseFloat(e.target.value); // Ensure it's a number
										if (value >= 500) {
											alert("Value must be less than 500");
											return;
										}

										setRenkoDialogData((prev) => ({
											...prev,
											BrickSize: e.target.value
										}));
									}}
								/>

							</div>




						</div>


					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button className="Dialog_button"
						variant="outlined"
						color="error"
						onClick={handleCloseDialog}
					>
						No
					</Button>
					<Button className="Dialog_button"
						variant="outlined"
						color="success"
						onClick={handleValueChange}
						autoFocus
					>
						View
					</Button>
				</DialogActions>
			</Dialog>



{/* error dialog box */}
  <Dialog
			open={errorDialog}
			onClose={() => {
			  setErrorDialog(false);
			}}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		  >
			<DialogContent>
			  <DialogContentText id="alert-dialog-description">
				<div>
				 
				
					<span style={{ color: "black" }}>
					{errorMsz}
					</span>
			
				  
				</div>
			  </DialogContentText>
			</DialogContent>
		  </Dialog>


		</>

	);
}





export default ViewRenko

